// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3FJux","content":"LoadingAlert_content__K5vX5"};